import { Persist } from "./persist";

export { Persist };

globalThis["NeuronPersist"] = {
  Persist,
};
